<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card :title="'Manage Staff Leave'" class="">
                <vx-card cardBorder noShadow subtitle="Filters">
                    <div class="vx-row mb-3">
                        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Staff Users</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="true"
                                v-model="filters['staff']" :options="filtered_staff_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.value" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Leave Reviewer</label>
                            <v-select name="leave-reviewer-ids" :closeOnSelect="true" :clearable="true"
                                v-model="filters['leave-reviewer-ids']" :options="leave_reviewers" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.id" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Leave Status</label>
                            <v-select :clearable="true" placeholder="" v-model="filters['status']" multiple
                                :options="['Pending', 'Approved', 'Rejected', 'Cancelled']"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Leave Type</label>
                            <v-select :clearable="true" placeholder="" v-model="filters['type']" multiple
                                :options="leave_types" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            </v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full md:w-1/4 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Date Range</label>
                            <v-select :clearable="false" placeholder="" v-model="range_obj"
                                :options="rangeGenerator(['Next 7 Days', 'Next 14 Days', 'Next 28 Days', 'Choose Your Own Dates'])"
                                label="label" @input="onChangeRange()" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/4 sm:w-1/2" v-if="range_obj.value === 'own_dates'">
                            <label class="text-sm opacity-100 text-bold">Leave Date From</label>
                            <flat-pickr :config="flatPkrConfig" v-model="filters['from']" class="w-full"
                                placeholder="" />
                        </div>
                        <div class="w-full vx-col md:w-1/4 sm:w-1/2" v-if="range_obj.value === 'own_dates'">
                            <label class="text-sm opacity-100 text-bold">Leave Date To</label>
                            <flat-pickr :config="flatPkrConfig" v-model="filters['to']" class="w-full" placeholder="" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="w-full ml-auto vx-col">
                            <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                                icon-pack="feather" v-on:click="filters = {}">CLEAR</vs-button>
                        </div>
                    </div>
                </vx-card>
                <div class="flex mt-6">
                        <vs-button color="primary" type="filled" size="small"
                            @click="onClickCreateLeave()" icon-pack="feather" icon="icon-plus" class="mr-0 ml-auto" v-if="canCreateLeave">
                            Apply for Leave
                        </vs-button>
                        <vs-button color="primary" type="border" size="small" @click="refreshData()"
                            icon-pack="feather" icon="icon-refresh-cw" :class="canCreateLeave ? 'ml-2' : 'ml-auto'">
                            Refresh
                        </vs-button>
                </div>
                <div id="staff-leaves-table" class="vx-row">
                    <div class="w-full vx-col">

                        <vs-table stripe sort class="mt-8" :data="staff_leaves">
                            <template slot="thead">
                                <vs-th>Requested By</vs-th>
                                <vs-th>Leave Period</vs-th>
                                <vs-th>Type & Duration</vs-th>
                                <vs-th>Request Approval From</vs-th>
                                <vs-th>Status</vs-th>
                                <vs-th>Status Changed By</vs-th>
                                <vs-th>Applied Date</vs-th>
                                <vs-th v-if="$store.getters.currentUser.role.name === 'Admin' || staff_leaves.some(l => l.leave_reviewer_id === $store.getters.currentUserId) || staff_leaves.some(l => !l.leave_reviewer_id)" width="20%">Reason</vs-th>
                                <vs-th width="15%"></vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td>
                                        {{ data[indextr].staff.name }}
                                    </vs-td>

                                    <vs-td class="text-primary font-bold">
                                        {{ formatDateRange(data[indextr].start_date, data[indextr].end_date) }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].description">
                                        <!-- <vx-read-more :length="100" :text="data[indextr].description" /> -->
                                        <div class="text-sm text-gray-900">{{ data[indextr].leave_type }}</div>
                                        <div class="text-sm text-gray-500">
                                            {{ data[indextr].total_days }}
                                            {{ data[indextr].total_days == 1 ? 'day' : 'days' }}
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <span v-if="data[indextr].leave_reviewer_id">
                                            {{ data[indextr].leave_reviewer.name }}
                                        </span>
                                        <span v-else>N/A</span>
                                    </vs-td>

                                    <vs-td>
                                        <vs-chip :color="getStatusClass(data[indextr].status)" transparent>
                                            {{ data[indextr].status }}
                                        </vs-chip>
                                    </vs-td>

                                    <vs-td>
                                        {{ data[indextr].approver ? data[indextr].approver.name : 'N/A' }}
                                    </vs-td>

                                    <vs-td>
                                        {{ __dateTimeFormatter(data[indextr].created_at) }}
                                    </vs-td>

                                    <vs-td>
                                        <span v-if="data[indextr].leave_reviewer_id === $store.getters.currentUserId || !data[indextr].leave_reviewer_id || $store.getters.currentUser.role.name === 'Admin'">
                                            <div class="text-sm text-gray-900 max-w-xs">
                                                {{ data[indextr].reason }}
                                            </div>
                                            <div v-if="data[indextr].notes" class="text-sm text-gray-500 max-w-xs" style="white-space: pre-line;">
                                                <vx-read-more :text="data[indextr].notes || ''" />
                                            </div>
                                        </span>
                                    </vs-td>

                                    <vs-td>
                                        <div class="flex items-center"
                                            v-if="$can('edit-staff-leaves')">
                                            <vx-tooltip text="View Logs" position="top" class="mr-2" style="align-self: flex-end; margin-bottom: 8px;"
                                                v-if="data[indextr].leave_reviewer_id === $store.getters.currentUserId || !data[indextr].leave_reviewer_id || $store.getters.currentUser.role.name === 'Admin'">
                                                <vs-button @click.stop="$refs.leaveRequestLogsPopUp.openPopup(data[indextr].id)"
                                                    size="small" color="primary" type="border" icon-pack="feather" icon="icon-list"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip text="Modify Leave Request" position="top" v-if="$can('edit-staff-leaves')" style="align-self: flex-end; margin-bottom: 8px;">
                                                <vs-button @click.stop="onClickModifyLeaveRequest(data[indextr].id)"
                                                    size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                                            </vx-tooltip>
                                            <div v-if="data[indextr].status === 'Pending' && (data[indextr].leave_reviewer_id === $store.getters.currentUserId || !data[indextr].leave_reviewer_id)"
                                                class="ml-1 mt-1 p-2">
                                                <p class="text-xs font-semibold mb-1 text-grey-dark">Leave Request</p>
                                                <div class="flex items-center" style="gap: 4px;">
                                                    <vx-tooltip text="Approve Request" position="top">
                                                        <vs-button @click.stop="onClickStatusChange('approve', data[indextr].id)"
                                                            size="small" color="primary" type="border" icon-pack="feather" icon="icon-check">Approve</vs-button>
                                                    </vx-tooltip>
                                                    <vx-tooltip text="Reject Request" position="top">
                                                        <vs-button @click.stop="onClickStatusChange('reject', data[indextr].id)"
                                                            size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">Reject</vs-button>
                                                    </vx-tooltip>
                                                </div>
                                            </div>
                                            <div v-if="data[indextr].status === 'Approved' && data[indextr].cancel_request !== null && data[indextr].cancel_request.status == 'Pending' && (data[indextr].leave_reviewer_id === $store.getters.currentUserId || !data[indextr].leave_reviewer_id)"
                                                class="ml-1 mt-1 p-2">
                                                <div class="flex items-center mb-1" style="gap: 4px;">
                                                    <p class="text-xs font-semibold text-grey-dark">Leave Cancellation Request</p>
                                                    <vx-tooltip :title="'Reason for Cancellation'" :text="data[indextr].cancel_request && data[indextr].cancel_request.reason ? data[indextr].cancel_request.reason : 'N/A'" position="top">
                                                        <feather-icon icon="InfoIcon" svgClasses="h-5 w-5 text-warning cursor-pointer" />
                                                    </vx-tooltip>
                                                </div>
                                                <div class="flex items-center" style="gap: 4px;">
                                                    <vx-tooltip text="Approve Cancellation" position="top">
                                                        <vs-button @click.stop="openCancellationModerationPrompt(data[indextr].id, 'cancellations/approve')"
                                                            size="small" color="primary" type="border" icon-pack="feather" icon="icon-check">Approve</vs-button>
                                                    </vx-tooltip>
                                                    <vx-tooltip text="Reject Cancellation" position="top">
                                                        <vs-button @click.stop="openCancellationModerationPrompt(data[indextr].id, 'cancellations/reject')"
                                                            size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">Reject</vs-button>
                                                    </vx-tooltip>
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </vx-card>
            <ManageStaffLeavesEntitlements class="mt-8" />
        </div>
        <vs-prompt @cancel="status_change_obj = {}" @accept="changeLeaveRequestStatus" @close="activePrompt = false"
            :title="status_change_obj.status === 'approve' ? 'Approve leave request' : status_change_obj.status === 'reject' ? 'Reject leave request' : 'Cancel price request'"
            :accept-text="'Submit'" :color="status_change_obj.status === 'approve' ? 'primary' : 'danger'"
            :active.sync="activePrompt">
            <div class="con-exemple-prompt">
                <span>Notes</span>
                <vs-textarea class="mt-3 w-full" v-model="status_change_obj.notes"></vs-textarea>
            </div>
        </vs-prompt>
        <vs-prompt @cancel="cancellation_moderation_obj = {}" @accept="handleCancellationModeration" @close="activeCancellationPrompt = false"
            :title="cancellation_moderation_obj.type === 'cancellations/approve' ? 'Approve Cancellation Request' : 'Reject Cancellation Request'"
            :accept-text="'Confirm'" :color="cancellation_moderation_obj.type === 'cancellations/approve' ? 'primary' : 'danger'"
            :active.sync="activeCancellationPrompt">
            <div class="con-exemple-prompt">
                <span>Remarks</span>
                <vs-textarea class="mt-3 w-full" v-model="cancellation_moderation_obj.remarks"></vs-textarea>
            </div>
        </vs-prompt>
        <CreateLeavesPopUp ref="createLeavesPopUp" :isRequestFromProfile="false" />
        <status-log-pop-up
            ref="leaveRequestLogsPopUp"
            title="Leave Request Logs"
            :columns="leaveLogColumns"
            :fetch-fn="fetchLeaveLogs">
            <template #rows="{ data, buildDiffRows }">
                <vs-tr :key="i" v-for="(_, i) in data">
                    <vs-td :data="data[i].created_at">{{ __dateTimeFormatter(data[i].created_at) }}</vs-td>
                    <vs-td :data="data[i].event">{{ data[i].event }}</vs-td>
                    <vs-td :data="data[i].causer">{{ data[i].causer ? data[i].causer.name : '' }}</vs-td>
                    <template slot="expand">
                        <div class="con-expand-users w-4/5 p-4">
                            <p v-if="data[i].properties && data[i].properties.data && data[i].properties.data.reason" class="text-sm mb-4"><strong>Reason:</strong> {{ data[i].properties.data.reason }}</p>
                            <vs-table v-if="buildDiffRows(data[i].properties).length" noDataText="" class="w-full">
                                <template slot="thead">
                                    <vs-th>FIELD</vs-th>
                                    <vs-th>PREVIOUS VALUE</vs-th>
                                    <vs-th>NEW VALUE</vs-th>
                                </template>
                                <template>
                                    <vs-tr v-for="(row, j) in buildDiffRows(data[i].properties)" :key="j">
                                        <vs-td>{{ row.field }}</vs-td>
                                        <vs-td>{{ row.old }}</vs-td>
                                        <vs-td>{{ row.new }}</vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                            <p v-else class="text-grey text-sm">No field changes recorded for this event.</p>
                        </div>
                    </template>
                </vs-tr>
            </template>
        </status-log-pop-up>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const LeaveRepository = RepositoryFactory.get('leave');
const DropdownRepository = RepositoryFactory.get('drop_down');

import { mapActions, mapGetters } from 'vuex';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import vSelect from 'vue-select'

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
import ManageStaffLeavesEntitlements from './ManageStaffLeavesEntitlements'
import ShortcutCard from '@/components/shortcut-cards/ShortcutCard.vue'
import moment from "moment/moment";
import Utils from "@/mixins/Utils";

import CreateLeavesPopUp from "@/components/popups/manage-leaves/CreateLeavesPopUp.vue"
import StatusLogPopUp from "@/components/popups/activity-logs/StatusLogPopUp.vue"

export default {
    name: "ManageStaffLeaves",
    data() {
        return {
            staff_leaves: [],
            upcoming_leaves: [],
            filters: {
                from: '',
                to: ''
            },
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            status_change_obj: {
                status: '',
                id: '',
                notes: ''
            },
            activePrompt: false,
            activeCancellationPrompt: false,
            cancellation_moderation_obj: {},
            admin_stats: {},
            leave_types: [
                'Annual Leave',
                'Sick Leave',
                'Training Leave',
                'Emergency Leave',
                'Unpaid Leave',
                'Maternity Leave',
                'Paternity Leave',
                'Compassionate Leave'
            ],
            range_obj: {
                value: null
            },
            leave_reviewers: [],
            leaveLogColumns: [
                { label: 'DATE/TIME',  width: '30%' },
                { label: 'EVENT TYPE', width: '30%' },
                { label: 'DONE BY',    width: '40%' },
            ],
        }
    },
    components: {
        'v-select': vSelect,
        flatPickr,
        ManageStaffLeavesEntitlements,
        ShortcutCard,
        CreateLeavesPopUp,
        StatusLogPopUp,
    },
    methods: {
        ...mapActions(['fetchStaffs']),
        async fetchLeaveLogs(id, page, perPage) {
            const response = (await LeaveRepository.getLeaveRequestLogs(id, page, '', perPage, 1)).data
            return { logs: response.data || [], meta: response.meta }
        },
        async refreshData() {
            await this.fetchStaffLeaves()
            await this.fetchAdminStats()
            // await this.fetchUpcomingLeaves()
        },
        async fetchStaffLeaves() {
            await this.$vs.loading({
                container: '#staff-leaves-table',
                scale: 0.45
            })
            const { data } = await LeaveRepository.getAllStaffLeaves(this.page, `filter[from]=${this.filters.from || ''}&filter[to]=${this.filters.to || ''}&filter[staff]=${this.filters.staff ? this.filters.staff.toString() : ''}&filter[leave-reviewer-ids]=${this.filters['leave-reviewer-ids'] ? this.filters['leave-reviewer-ids'].toString() : ''}&filter[status]=${this.filters.status ? this.filters.status.toString() : ''}&filter[type]=${this.filters.type ? this.filters.type.toString() : ''}`, this.perPage, this.sort)
            this.staff_leaves = data.data
            this.meta = data.meta
            this.$vs.loading.close('#staff-leaves-table > .con-vs-loading')
        },
        async fetchUpcomingLeaves() {
            try {
                const date_range = this.getNext7DaysRange()
                const { data } = (await LeaveRepository.getAllStaffLeaves(1, `filter[from]=${date_range.from}&filter[to]=${date_range.to}&filter[status]=Approved,Pending`, 50, '')).data
                this.upcoming_leaves = data
            } catch (error) {

            }
        },
        async fetchAdminStats() {
            try {
                const { data } = (await LeaveRepository.getAdminStats()).data
                this.admin_stats = data
            } catch (error) {

            }
        },
        onClickStatusChange(status, id) {
            this.status_change_obj = { status, id, notes: '' }
            this.activePrompt = true
        },
        async onClickCancelRequestConfirm(id) {
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Warning',
                            text: 'Do you want to cancel this request? This operation is irreversible.',
                            accept: this.onClickRequestToCancelLeaveRequest,
                            acceptText: 'Confirm',
                            parameters: [id]
                        })
        },
        openCancellationModerationPrompt(id, type) {
            this.cancellation_moderation_obj = { id, type, remarks: '' }
            this.activeCancellationPrompt = true
        },
        async handleCancellationModeration() {
            try {
                await LeaveRepository.changeLeaveRequestStatus(
                    this.cancellation_moderation_obj.id,
                    this.cancellation_moderation_obj.type,
                    { remarks: this.cancellation_moderation_obj.remarks }
                )
                this.activeCancellationPrompt = false
                this.cancellation_moderation_obj = {}
                await this.refreshData()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async changeLeaveRequestStatus() {
            try {
                await LeaveRepository.changeLeaveRequestStatus(this.status_change_obj.id, this.status_change_obj.status, { notes: this.status_change_obj.notes })
                this.activePrompt = false
                this.status_change_obj = {
                    status: '',
                    id: '',
                    notes: ''
                }
                await this.refreshData()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async onClickModifyLeaveRequest(id) {
            this.$refs.createLeavesPopUp.openPopup(id)
        },
        async onClickCreateLeave() {
            this.$refs.createLeavesPopUp.openPopup()
        },
        filterQueryUpdate() {
            this.fetchStaffLeaves()
        },

        handleChangePage(page) {
            this.page = page;
            this.fetchStaffLeaves()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchStaffLeaves()
            }
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        formatDateRange(startDate, endDate) {
            if (startDate === endDate) {
                return this.formatDate(startDate)
            }
            return `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`
        },
        formatDate(dateString) {
            // Convert from DD/MM/YYYY to readable format
            const [day, month, year] = dateString.split('/')
            const date = new Date(year, month - 1, day)
            return date.toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            })
        },
        getStatusClass(status) {
            const classes = {
                'Approved': 'primary',
                'Rejected': 'danger',
                'Pending': 'warning'
            }
            return classes[status] || 'dark'
        },
        getNext7DaysRange() {
            const from = moment().format("DD/MM/YYYY"); // today
            const to = moment().add(7, "days").format("DD/MM/YYYY"); // 7 days later

            return { from, to };
        },
        async onChangeRange() {
            if (this.range_obj.value !== 'own_dates') {
                let arr = this.range_obj.value.split(' to ')
                this.filters.from = arr[0]
                this.filters.to = arr[1]
                await this.fetchStaffLeaves()
            }
        },
        async fetchLeaveReviewers() {
            try {
                const { data } = (await DropdownRepository.getStaffLeaveReviewers()).data
                this.leave_reviewers = data
            } catch (error) {

            }
        },
    },
    async mounted() {
        // const ranges = this.rangeGenerator(['Next 7 Days', 'Next 14 Days'])
        await this.fetchStaffs()
        await this.fetchAdminStats()
        await this.fetchLeaveReviewers()
        // await this.fetchUpcomingLeaves()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages, Utils],
    computed: {
        ...mapGetters(['staffs']),
        canCreateLeave() {
            return this.$can('create-staff-leaves')
        },
        flatPkrConfig() {
            return {
                dateFormat: 'd/m/Y',
                locale: {
                    firstDayOfWeek: 1
                },
            }
        },
        filtered_staff_list() {
             return this.staffs.filter((staff) => {
                return staff.is_active === 1 && !!staff.is_leave_enabled
             } )  
        }
    },
    watch: {
        page() {
            this.fetchStaffLeaves()
        },
        perPage() {
            this.fetchStaffLeaves()
        }
    }
}
</script>

<style scoped></style>